import api from '.';
import { RotateQuestion } from '../pages/MasterData/RotateQuestion/rotateQuestionSlice';

interface ReturnTypeRotateQuestion {
  data: RotateQuestion[];
}

export async function getRotateQuestions(): Promise<ReturnTypeRotateQuestion> {
  const { data } = await api.get('/rotate-questions');

  return data;
}
